import { render } from "./ViewBonRetour.vue?vue&type=template&id=0c5c556d&scoped=true&ts=true"
import script from "./ViewBonRetour.vue?vue&type=script&lang=ts"
export * from "./ViewBonRetour.vue?vue&type=script&lang=ts"

import "./ViewBonRetour.vue?vue&type=style&index=0&id=0c5c556d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5c556d"]])

export default __exports__